import { useContext, useEffect, useState } from "react";
import DataContext from "../../store/data-context";
import InSiteLogo from "../../UI/InSiteLogo";
import Filters from "./Filters";
import List from "./List";
import styles from "./ServiceSelection.module.css";

export default function ServiceSelection({ setProcessIndex }) {
    const [speed, setSpeed] = useState({ value: 1000, label: "1000" });
    const {
        availableServices,
        setSelectedService,
        inHelp,
        setInHelp,
        serviceType,
        setServiceType,
        selectedAttributes,
        setSelectedAttributes,
    } = useContext(DataContext);
    const [filteredServices, setFilteredServices] = useState(
        availableServices || []
    );

    const inHelpValue = {
        title: "Filtriranje i odabir usluga",
        description: `Odaberite željenu internet uslugu iz dostupnih opcija. Možete filtrirati usluge prema maksimalnoj brzini i vrsti korisnika. <br/> <br/>
        <strong style="font-size: 15px">Vodič za odabir usuge:</strong><br/></br>
<strong>• Osnovno korištenje (do 10 Mbps): </strong> Pogodno za solo korisnike koji uglavnom pregledavaju internet, šalju e-poštu ili koriste društvene mreže. <br/> </br/>

<strong>• Umjereno korištenje (20-50 Mbps): </strong>  Idealno za obitelji ili manje kućanstvo s više uređaja.<br/> </br/>
<strong>• Intenzivnijee koristenje (75-300 Mbps): </strong>  Savršeno za tehnološki osviještene korisnike, gamere i radnike na daljinu.<br/> </br/>

<strong>• Napredno korištenje (300 Mbps i više): </strong>  Neophodno za stvaratelje sadržaja, velike obitelji i/ili kućne urede. <br/> </br/>
        Ako niste sigurni koju uslugu odabrati, slobodno kliknite `,
        active: false,
        moreQuestions: true,
        questions: [],
    };

    useEffect(() => {
        setInHelp({
            ...inHelpValue,
            quickTip: true,
        });
    }, []);

    useEffect(() => {
        if (inHelp.active === false) {
            setTimeout(() => {
                setInHelp((prevValue) => ({
                    ...inHelpValue,
                    quickTip: prevValue.quickTip,
                }));
            }, 250);
        }
    }, [inHelp.active]);

    const [serviceGroups, setServiceGroups] = useState([
        "FAST NET",
        "SUPER STREAM",
        "RUNE",
    ]);

    return (
        <div className={styles.container}>
            <InSiteLogo />
            <header className={styles.header}>
                <div className={styles.title}>
                    Istražite potencijalne <br /> usluge u vašoj blizini
                </div>
                <Filters
                    serviceTypes={serviceType}
                    setServiceTypes={setServiceType}
                    speed={speed}
                    setSpeed={setSpeed}
                    availableServices={availableServices}
                    setSelectedAttributes={setSelectedAttributes}
                    selectedAttributes={selectedAttributes}
                    setFilteredServices={setFilteredServices}
                    setServiceGroups={setServiceGroups}
                    setInHelp={setInHelp}
                />
            </header>
            <main className={styles.main}>
                <List
                    setProcessIndex={setProcessIndex}
                    setSelectedService={setSelectedService}
                    serviceTypes={serviceType}
                    serviceGroups={serviceGroups}
                    filteredServices={filteredServices}
                    setInHelp={setInHelp}
                    selectedAttributes={selectedAttributes}
                />
            </main>
        </div>
    );
}
